import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import MarginChip from "./MarginChip";

/*
  Compact recap of what's been chosen so far, shown from step 2 onward. The
  step rail carries the same information but drops its labels on narrow
  screens, and by step 3 the customer is several screens behind you.

  Most chips jump back to the step that owns them; margin is edited in place
  (see MarginChip) since it has no home in a step body anymore.
*/
const Chip = ({ label, value, onEdit }) => (
  <button
    type="button"
    onClick={onEdit}
    className="app-surface group flex items-center gap-2 rounded-xl border px-3 py-1.5 text-left transition hover:border-sky-500/60 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-500"
  >
    <span className="min-w-0">
      <span className="app-muted block text-[10px] font-semibold uppercase tracking-wider">
        {label}
      </span>
      <span className="block max-w-[180px] truncate text-xs font-semibold">
        {value}
      </span>
    </span>
    <EditIcon
      className="app-muted shrink-0 opacity-0 transition group-hover:opacity-100"
      sx={{ fontSize: 13 }}
    />
  </button>
);

const SelectionSummary = ({
  formData,
  setFormData,
  onEditStep,
  className = "",
}) => {
  const customerLabel =
    formData.customer ||
    (formData.account ? `Account #${formData.account}` : "—");

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <Chip
        label="Customer"
        value={customerLabel}
        onEdit={() => onEditStep(1)}
      />
      {formData.job && (
        <Chip
          label="Job"
          value={`#${formData.job}`}
          onEdit={() => onEditStep(1)}
        />
      )}
      <Chip
        label="Type"
        value={(formData.form_type || "quote") === "order" ? "Order" : "Quote"}
        onEdit={() => onEditStep(2)}
      />
      <MarginChip formData={formData} setFormData={setFormData} />
    </div>
  );
};

export default SelectionSummary;
